import { apiHost } from '../../../config';
import { get } from '../../requests';

export default async function getAllGradesAsAdmin() {
  return get(`${apiHost}/api/admin/grades`);
}
